import _get from 'lodash/get';


const getPayoutRequestAvailability = state => (
  _get(state, 'payout.payoutRequestAvailability.data')
);
export const getIsPayoutAvailable = state => (
  _get(getPayoutRequestAvailability(state), 'isPayoutAvailable')
);
export const getLoadPayoutRequestAvailabilityError = state => (
  _get(state, 'payout.payoutRequestAvailability.errors.loadError')
);
